import { useEffect, useState, useContext } from "react";
import { useLocation } from "react-router-dom";
import { Input } from "design-react-kit";
import Repo from "../../Utility/Repo";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";
import ViewPDF from "../../Components/ViewPDF";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function CheckISEE(props) {
  const apiToken = useContext(TokenContext);
  const [value, setValue] = useState("");
  const [protocollo, setProtocollo] = useState("");
  const [scadenza, setScadenza] = useState("");
  const [file, setFile] = useState();
  const [year, setYear] = useState();
  const [userData, setUserData] = useState();
  const [validation, setValidation] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isee, setIsee] = useState({});


  let query = useQuery();
  let idIsee = query.get("idIsee");

  const stateMap = {
    LOAD: 0,
    VALIDATED: 1,
    REFUSED: 2,
    ERROR: 3,
  };

  const stateLabels = {
    0: "Caricato",
    1: "Validato",
    2: "Rifiutato",
    3: "Errore",
  };


    const [state, setState] = useState(0);
  const [selectedType, setSelectedType] = useState("ordinario");
  const isError = state === stateMap.ERROR;
  const isRefused = state === stateMap.REFUSED;
  const isLocked = !!isee?.usedInPayment;

  const toNumber = (v) => {
    if (v === null || v === undefined || v === "") return null;
    const n = typeof v === "number" ? v : parseFloat(String(v).replace(",", "."));
    return Number.isFinite(n) ? n : null;
  };

  const sameValue = (a, b) => {
    const na = toNumber(a);
    const nb = toNumber(b);
    if (na === null || nb === null) return false;
    return Math.abs(na - nb) < 0.005;
  };

  const formatIseeAmount = (v) => {
    const n = toNumber(v);
    if (n === null) return "N/A";
    return n.toLocaleString("it-IT", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const resolveSelectedType = (data) => {
    const ristretto = toNumber(data?.ristretto);
    const ordinario = toNumber(data?.ordinario);
    const current = toNumber(data?.value);

    if (sameValue(ristretto, ordinario)) {
      return "ordinario";
    }
    if (ristretto !== null && current !== null && sameValue(current, ristretto)) {
      return "ristretto";
    }
    return "ordinario";
  };

  const applyIseeType = (type) => {
    setSelectedType(type);
    const nextValue =
      type === "ristretto" ? isee?.ristretto : isee?.ordinario;
    setValue(nextValue ?? "");
  };

  const selectedAmount = () => {
    if (selectedType === "ristretto") {
      return toNumber(isee?.ristretto);
    }
    return toNumber(isee?.ordinario);
  };

  useEffect(() => {
    setLoading(false);
    if (idIsee) {
      var obj = document.createElement("object");
      obj.type = "application/pdf";
      obj.data = "data:application/pdf;base64,";
      obj.length = 0;
      setFile(obj);

      Repo.getIsee(apiToken, idIsee)
        .then((response) => {
          if (response.status === 200) {
            obj.data = "data:application/pdf;base64," + response.data.file;
            obj.length = response.data.file.length;
            setFile(obj);
            setValue(response.data.value);
            setProtocollo(response.data.protocollo);
            setYear(response.data.year);
            //  setState(response.data.state); // <-- inizializza lo stato ISEE
            console.log(response.data);

            const data = response.data;
            setSelectedType(resolveSelectedType(data));

            const stato = response.data.state;

            setState(stateMap[stato] ?? 0);

            // 🔥 Conversione della data da 31/12/2024 ➔ 2024-12-31
            const formattedScadenza = data.scadenza
              ? data.scadenza.split("/").reverse().join("-")
              : "";

            setScadenza(formattedScadenza);
            setIsee(response.data);
            setUserData(response.data.user);
          }
          setLoading(true);
        })
        .catch((error) => {
          console.log(error);
          setLoading(true);
        });
    }
  }, []);

  const updateISEE = async () => {
    const copiedValue = selectedAmount();
    const updatedData = {
      id: idIsee,
      userId: userData?.id,
      value: copiedValue ?? toNumber(value),
      protocollo: protocollo,
      scadenza: scadenza,
      state: state,
      year: toNumber(year) ?? year,
    };

    if (updatedData.value === null || updatedData.value === undefined) {
      alert("Seleziona un valore ISEE ordinario o ristretto");
      return;
    }

    try {
      const response = await Repo.postConfirmIsee(apiToken, updatedData);
      if (response.status === 200) {
        const redirectTo =
          process.env.PUBLIC_URL +
          `/lista_utenti/dati_utente?citizen=${userData.id}&tab=isee`;
        window.location.href = redirectTo;
      } else {
        alert("Errore durante l'aggiornamento dell'ISEE");
      }
    } catch (error) {
      console.error(error);
      const msg =
        error?.response?.data ||
        error?.response?.statusText ||
        "Errore tecnico durante il salvataggio";
      alert(typeof msg === "string" ? msg : "Errore tecnico durante il salvataggio");
    }
  };

  return (
    <>
      <div>
        <h1>ISEE</h1>
        <div className="clearfix col-lg-8 py-lg-2">
          <p>Visualizza o modifica i dettagli dell'ISEE</p>
        </div>

        <div className="row mb-2">
          <div className="col-12">
            <div className="top card-wrapper card-space">
              <div className="card card-bg no-after roundedCustom p-2">
                <div className="card-body">
                  <h6 className="mb-1">Dati Cittadino</h6>
                  <div className="row">
                    <div className="col-lg-4">
                      Nome: <strong>{userData && userData.firstName}</strong>
                    </div>
                    <div className="col-lg-4">
                      Cognome: <strong>{userData && userData.lastName}</strong>
                    </div>
                    <div className="col-lg-4">
                      Codice Fiscale:{" "}
                      <strong>{userData && userData.fiscalCode}</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <ViewPDF data={file && file.data} length={file && file.length} />

          <div className="col-lg-4 pl-3">
            <div className="top card-space">
              <div className="card card-bg card-big roundedCustom">
                <div className="card-body">
                  {isLocked && (
                    <div className="alert alert-warning">
                      ISEE utilizzato in un pagamento: non modificabile né
                      cancellabile.
                    </div>
                  )}
                  <h6 className="mt-3 mb-1">Valore</h6>
                  <div className="mb-3">
                    <label className="d-block">
                      <input
                        type="radio"
                        name="tipoIsee"
                        value="ordinario"
                        checked={selectedType === "ordinario"}
                        disabled={isLocked}
                        onChange={() => applyIseeType("ordinario")}
                      />
                      &nbsp;ISEE Ordinario ({formatIseeAmount(isee?.ordinario)})
                    </label>
                    <label className="d-block">
                      <input
                        type="radio"
                        name="tipoIsee"
                        value="ristretto"
                        checked={selectedType === "ristretto"}
                        disabled={isLocked}
                        onChange={() => applyIseeType("ristretto")}
                      />
                      &nbsp;ISEE Ristretto ({formatIseeAmount(isee?.ristretto)})
                    </label>
                  </div>
                  <div className="row mb-4">
                    <input
                      id="value"
                      className="form-control"
                      type="number"
                      required
                      readOnly
                      value={value ?? ""}
                      name="Valore ISEE"
                    />
                  </div>

                  <h6 className="mt-3 mb-1">Protocollo</h6>
                  <div className="row mb-4">
                    <Input
                      id="protocollo"
                      type="text"
                      required
                      value={protocollo}
                      name="Protocollo ISEE"
                      disabled={isLocked}
                      onChange={(e) => setProtocollo(e.target.value)}
                    />
                  </div>
                  <h6 className="mt-3 mb-1">Anno</h6>
                  <div className="row mb-4">
                    <Input
                      id="year"
                      type="text"
                      required
                      value={year}
                      name="Anno"
                      disabled={isLocked}
                      onChange={(e) => setYear(e.target.value)}
                    />
                  </div>

                  <h6 className="mt-3 mb-1">Scadenza</h6>
                  <div className="row mb-4">
                    <Input
                      id="scadenza"
                      type="date"
                      required
                      value={scadenza}
                      name="Scadenza ISEE"
                      disabled={isLocked}
                      onChange={(e) => setScadenza(e.target.value)}
                    />
                  </div>

                  <h6 className="mt-3 mb-1">Stato</h6>
                  <div className="row mb-4">
                    <select
                      className="form-control"
                      value={state}
                      disabled={isLocked}
                      onChange={(e) => setState(parseInt(e.target.value))}
                    >
                      {Object.entries(stateLabels).map(([val, label]) => (
                        <option key={val} value={val}>
                          {label}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="clear"></div>
                  {isRefused && (
                    <div className="alert alert-warning">
                      {isee?.detail ?? "ISEE rifiutato"}
                    </div>
                  )}

                  {isError && (
                    <div className="alert alert-danger">
                      {isee?.omissioneDifformita ||
                        isee?.detail ||
                        "Errore durante la verifica dell'ISEE"}
                    </div>
                  )}

                  {!isError && isee?.omissioneDifformita && (
                    <div className="alert alert-danger">
                      <strong>Omissione/Difformità:</strong>
                      <div className="mt-1">{isee.omissioneDifformita}</div>
                    </div>
                  )}

                  <div className="text-right mt-4">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={updateISEE}
                      disabled={isLocked}
                    >
                      Salva Modifiche
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {!loading && <Loader />}
    </>
  );
}

export default CheckISEE;
